// extracted by mini-css-extract-plugin
export default {"menu-item":"MainPage_menu-item__trtLN","cards":"MainPage_cards__libnU"};